import { Button, Icon, Typography } from 'darrius';
import { Step } from '../../../components';

export const ChangePasswordSuccess = ({ onButtonClick }) => {
  return (
    <Step.Root>
      <Step.Header>
        <Icon
          size={106}
          src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/comunicacao.svg`}
          alt="Ícone de mensagem"
        />
        <Typography.Subtitle size="l" className="spacing-stack-bottom-300">
          Para definir sua senha, digite seu e-mail cadastrado abaixo
        </Typography.Subtitle>
        <Typography.Text className="spacing-stack-bottom-500">
          Abra o link enviado para o e-mail cadastrado e siga os passos para
          alterar sua senha.
        </Typography.Text>
      </Step.Header>
      <Step.Body>
        <Step.Actions>
          <Button.Root
            type="button"
            size="small"
            fullWidth
            variation="clear"
            onClick={onButtonClick}
          >
            Reenviar e-mail
          </Button.Root>
        </Step.Actions>
      </Step.Body>
    </Step.Root>
  );
};
